export default __webpack_public_path__ + "static/media/gallery_02.1a37f9ad.jpg";